module.exports = __webpack_public_path__ + "static/img/44.435f0fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/enterpriseDia/44.png
// module id = w4Xz
// module chunks = 2